<td colspan="{{columnCount}}" class="js-region-grid-subrow"></td>